<template>
  <article class="plan billing-plan-overview" :class="'plan-' + plan.id">
    <section>
      <h1>{{ plan.name | text }}</h1>
      <Cell class="price" :item=plan :field=priceField :name=priceFieldName />
      <Cell class="credits" :item=plan :field=creditField name=credits />
      <Item class="striped" :item=plan :fields=fields[0] />
    </section>
    <section>
      <h2>{{ 'billings:support' | trans }}</h2>
      <Item class="striped" :item=plan :fields=fields[1] />
    </section>
  </article>
</template>

<script>
  import Cell from '@/helpers/components/display/Cell'
  import Item from '@/helpers/components/display/Item'
  import {billings_plans as billing_fields} from '../fields'
  import _ from 'lodash'

  export default {
    name: 'PlanOverview',
    components: {Cell, Item},
    data () {
      var fields = [
        _.pick(billing_fields, [
          'credits_price',
          'credits_per_request_default',
          'options_locked_after_cap',
        ]),
        _.pick(billing_fields, [
          'options_basic_support', 'options_email_support_24',
          'options_phone_support_24', 'options_tech_support',
        ]),
      ];
      return {
        fields,
        creditField: billing_fields.credits || {},
      };
    },
    props: {
      cycle: {default: 'monthly',},
      plan: {required: true,},
    },
    computed: {
      priceFieldName () {return 'prices_subscription_' + this.cycle;},
      priceField () {return billing_fields[this.priceFieldName];},
    },
  }
</script>

<style lang="scss">
  @mixin plan-color($color) {
    > section {
      &, > .price {
        border-color: $color;
      }
      > h1, > h2, > h3, > h4, > h5, > h6 {
        &:first-child {
          background: $color;
          border-color: $color;
        }
      }
      .svg-icon.active, > .credits dd {
        color: $color;
      }
    }
  }

  article.billing-plan-overview {
    @media (min-width: $md-min) {
      margin: 50px;
    }
    @include plan-color($accent);
    @each $id, $color in $plan-colors {
      &.#{'plan-' + $id} {
        @include plan-color($color);
      }
    }
    > section {
      margin: 20px 0;
      border: solid 2px;
      padding: 0 0 30px;
      @media (min-width: $sm-min) {
        > * {
          margin-left: 30px;
          margin-right: 30px;
        }
      }
      > .price, > .credits {
        font-weight: 700;
        @include font-size(40px);
        border-bottom: solid 2px;
        padding: 0 30px 30px;
        margin: 0 0 30px;
        dt {
          display: block;
          font-size: 20px;
          font-weight: 400;
          &::after {
            content: none;
          }
        }
        svg {
          transform: none;
        }
      }
      > h1, > h2, > h3, > h4, > h5, > h6 {
        @include font-size(24px, 29px);
        text-transform: capitalize;
        font-weight: 400;
        margin: 0 0 30px;
        &:first-child {
          color: white;
          border-bottom: solid 2px;
        }
      }
      > h1:first-child {
        font-weight: 700;
        letter-spacing: 0.025em;
        text-transform: uppercase;
        @include font-size(26px, 49px);
      }
    }
    @media (min-width: $sm-min) {
      .striped {
        width: calc(100% - 60px) !important;
        dl > * {
          padding: 10px 35px !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/billings/components/PlanOverview.vue